import React from 'react';

import type { StickyType } from '@core/StickyScroll';

type TemporaryDrawerContextValue = {
  sticky?: StickyType;
  id?: string;
  headingGroupId?: string;
  onClose?: (e: React.MouseEvent | React.KeyboardEvent) => void;
};

const Context = React.createContext<TemporaryDrawerContextValue>({
  onClose: undefined,
  id: undefined,
  headingGroupId: undefined,
});

if (__DEV__) {
  Context.displayName = 'TemporaryDrawerContext';
}

const TemporaryDrawerContextProvider = Context.Provider;

const useTemporaryDrawerContext = (): TemporaryDrawerContextValue =>
  React.useContext(Context);

export { TemporaryDrawerContextProvider, useTemporaryDrawerContext };
